import type { Currency } from '../shared/contracts';
import { resolveWidgetLanguage } from './i18n';

export function formatPrice(
  value: number,
  currency: Currency,
  locale = 'en',
): string {
  const amount = new Intl.NumberFormat(resolveWidgetLanguage(locale), {
    maximumFractionDigits: 2,
  }).format(value);
  return currency.position === 'before'
    ? `${currency.symbol}${amount}`
    : `${amount} ${currency.symbol}`;
}

function formatUnit(
  value: number,
  unit: 'hour' | 'minute',
  locale: string,
): string {
  return new Intl.NumberFormat(resolveWidgetLanguage(locale), {
    style: 'unit',
    unit,
    unitDisplay: 'short',
  }).format(value);
}

export function formatDuration(minutes: number, locale = 'en'): string {
  if (minutes < 60) return formatUnit(minutes, 'minute', locale);
  const hours = Math.floor(minutes / 60);
  const remainder = minutes % 60;
  const formattedHours = formatUnit(hours, 'hour', locale);
  return remainder
    ? `${formattedHours} ${formatUnit(remainder, 'minute', locale)}`
    : formattedHours;
}

export function formatDisplayDate(date: string, locale = 'en'): string {
  return new Intl.DateTimeFormat(resolveWidgetLanguage(locale), {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
  }).format(new Date(`${date}T12:00:00Z`));
}
